import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JsonApiListWrap, JsonApiWrap } from '../models/JsonApiWrap';
import { SharedActions } from '../actions';
import { HttpMethods } from '../utilities/Constants';

@Injectable()
export class BaseRestService {
    constructor(private http: HttpClient, private store: Store) { }

    get<TResponse>(
        url: string,
        headers: {
            [name: string]: string;
        },
        isJsonApi: boolean
    ): Observable<TResponse> {
        if (isJsonApi) {
            return this.http.get<JsonApiWrap<TResponse>>(url, { headers }).pipe(map((res) => res.data.attributes));
        }

        return this.http.get<TResponse>(url, { headers }).pipe(map((res) => res));
    }

    post<TRequest, TResponse>(
        url: string,
        headers: {
            [name: string]: string;
        },
        requestBody: JsonApiWrap<TRequest> | TRequest,
        isJsonApi: boolean
    ): Observable<TResponse> {
        if (isJsonApi) {
            return this.http.post<JsonApiWrap<TResponse>>(url, requestBody, { headers }).pipe(map((res) => res.data.attributes));
        }
        return this.http.post<TResponse>(url, requestBody, { headers }).pipe(map((res) => res));
    }

    // TODO: Remove all above methods and use below method throughout the project
    request<TRequest, TResponse>(
        url: string,
        headers: {
            [name: string]: string;
        },
        requestBody: JsonApiWrap<TRequest> | TRequest,
        httpMethod: HttpMethods,
        isJsonApi: boolean
    ): Observable<TResponse> {
        if (isJsonApi) {
            return this.http.request<JsonApiWrap<TResponse>>(httpMethod, url, { body: requestBody, headers: headers }).pipe(map((res) => res.data.attributes));
        }

        return this.http.request<TResponse>(httpMethod, url, { body: requestBody, headers }).pipe(map(res => res))
    }

    requestJsonApiList<TRequest, TResponse = TRequest>(
        url: string,
        headers: {
            [name: string]: string;
        },
        requestBody: JsonApiWrap<TRequest> | TRequest,
        httpMethod: string,
    ): Observable<TResponse[]> {
        return this.http.request<JsonApiListWrap<TResponse>>(httpMethod, url, { body: requestBody, headers: headers }).pipe(map(res => res.data.map(({attributes}) => attributes)));
    }

    requestJsonApiListWithMetadata<TRequest, TResponse = TRequest>(
      url: string,
      headers: {
        [name: string]: string;
      },
      requestBody: JsonApiWrap<TRequest> | TRequest,
      httpMethod: string,
    ): Observable<{ id: string; type: string; attributes: TResponse }[]> {
      return this.http.request<JsonApiListWrap<TResponse>>(httpMethod, url, { body: requestBody, headers }).pipe(
        map(res => res.data.map(
          item => ({
            id: item.id,
            type: item.type,
            attributes: item.attributes
          })
        ))
      );
    }
}
